const TRAINER_INVITE_STORAGE_KEY = 'grounded:trainer-invite'

export const buildTrainerInviteUrl = (
  trainerId: string,
  origin = typeof window === 'undefined' ? '' : window.location.origin
) => `${origin}/join/${trainerId}`

export const savePendingTrainerInvite = (trainerId: string) => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(TRAINER_INVITE_STORAGE_KEY, trainerId)
}

export const getPendingTrainerInvite = () => {
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage.getItem(TRAINER_INVITE_STORAGE_KEY)
}

export const clearPendingTrainerInvite = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.removeItem(TRAINER_INVITE_STORAGE_KEY)
}
